import styles from './Image.module.scss'
import cx from 'classnames'
import React from 'react'

type ImageProps = {
    src: string
    alt: string
    classes?: string
    width?: string | number
    height?: string | number
    objectFit?: 'contain' | 'cover'
}

const Image: React.FC<ImageProps> = ({
    src,
    alt,
    classes,
    width = '100%',
    height,
    objectFit = 'contain',
}: ImageProps) => {
    const className = cx(styles['zr-image'], classes)

    return (
        <img
            className={className}
            src={src}
            alt={alt}
            width={width}
            height={height}
            style={{ objectFit: objectFit }}
        />
    )
}

export default Image
